<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 13:56:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-07 10:34:14
 * @Description: checkbox group
 * @FilePath: /hsylc2021/src/components/form/CheckboxGroup/index.vue
-->
<template>
  <Prototype
    :CheckboxClass="CheckboxClass"
    :className="className"
    :disabled="disabled"
    :value="value"
    :options="options"
    :keyStr="keyStr"
    :reverse="reverse"
    :multi="multi"
    @input="handleInput"
  >
    <div v-if="isError" class="errmsg">{{ errmsgVal }}</div>
  </Prototype>
</template>
<script>
import Prototype from './Prototype';
/**
 * checkbox group组件
 * @module CheckboxGroup
 */
export default {
  name: 'CheckboxGroup',
  components: {
    Prototype
  },
  /**
   * @prop {String} className 组件外部class
   * @prop {Boolean} disabled 是否禁用
   * @prop {Array} value 组件数据
   * @prop {Array} options 组件来源数据列表
   * @prop {String} keyStr 唯一标志字段名，默认value
   * @prop {Boolean} reverse 是否支持反选 默认true
   * @prop {Boolean} multi 是否支持多选 默认true
   * @prop {Boolean} errmsg 报错信息 默认 未填写
   * @prop {Boolean} startVerific 是否开启验证用户是否选择 默认false
   */
  props: {
    CheckboxClass: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyStr: {
      type: String,
      default: 'value'
    },
    reverse: {
      type: Boolean,
      default: true
    },
    multi: {
      type: Boolean,
      default: true
    },
    errmsg: {
      type: String,
      default: '未填写'
    },
    startVerific: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isError: false, // 是否
      errmsgVal: '未填写'
    };
  },
  watch: {
    errmsg(val) {
      this.errmsgVal = val;
    },
    startVerific(val) {
      if (val) this.checkGroup();
    },
    value() {
      if (this.startVerific) {
        this.checkGroup();
      }
    }
  },
  mounted() {
    this.errmsgVal = this.errmsg;
    if (this.startVerific) {
      this.checkGroup();
    }
  },
  methods: {
    // 检查 选项组 是否为空
    checkGroup() {
      // console.log('checkGroup:', this.value);
      // let ret = { ...this.value };
      let ret = this.value;
      let isError = ret.length === 0 ? true : false;
      this.isError = isError;
      return isError;
    },
    handleInput: function(value, curObj) {
      this.isError = !value.length;
      this.$emit('input', value, curObj, this.isError, this.errmsg);
    }
  }
};
</script>
<style lang="less" scoped></style>
